import { gql } from 'graphql-request'

export const REMOVE_MANY_CATEGORY_COVER = gql`
  mutation RemoveManyCategoryCover($ids: [Int!]!) {
    removeManyCategoryCover(ids: $ids) {
      id
    }
  }
`
